import { withStyles } from "@mui/styles";
import { injectIntl } from "react-intl";
import { Styles } from '../../../../styles/material-styles';
import { Container, Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { NotificationVariant } from "src/utils/enums/notification-variants.enum";
import AutoCompleteMultipleSelectSimple from "src/components/auto-complete/autocomplete-multiple-select-simple";
import * as LLMEventService from "../../../../services/llmevent.service.js";
import * as LLMService from "../../../../services/llm.service.js";
import EventDynamicAccordion from "./event-dynamic-accordion";

const LLMEventsDynamics = (props) => {
    const { classes, intl, llm, onShowNotification, onLoading } = props;

    const [eventsDynamics, setEventsDynamics] = useState([]);
    const [eventsSelected, setEventsSelected] = useState([]);

    const handleChangeEvents = async (value) => {  
        if (!value) value = [];

        // Verifica o que foi removido
        const removedItems = eventsSelected.filter((item) => !value.includes(item));

        if (removedItems.length > 0) {
            for (const item of removedItems) {
                const isRemoved = await onRemoveEventAsync(item);
                if (isRemoved) 
                    setEventsSelected(value);
            }
        } else {
            const newEvent = value[value.length - 1];
            const isSaved = await onSaveEventAsync(newEvent);
            if (isSaved)
                setEventsSelected(value);
        }
    }

    const onSaveEventAsync = async (_eventToSave) => {
        onLoading(true);

        try {
            const payload = {
                llmId: llm?.id, 
                llmEventId: _eventToSave?.id
            };

            const response = await LLMService.addEventDynamic(payload);
            if (response?.success) {
                onShowNotification("Evento adicionado com sucesso.");
                return true;
            } else {
                onShowNotification("Não foi possível salvar o evento.", NotificationVariant.ERROR);
                return false;
            }
        } catch (err) {
            onShowNotification("Não foi possível salvar o evento.", NotificationVariant.ERROR);
            return false;
        } finally {
            onLoading(false);
        }
    }

    const onRemoveEventAsync = async (_eventToRemove) => {
        onLoading(true);

        try {
            const response = await LLMService.deleteEventDynamicByLlmIdAndLlmEventId(llm?.id, _eventToRemove?.id);
            if (response?.success) {
                onShowNotification("Evento removido com sucesso.");
                return true;
            } else {
                onShowNotification("Não foi possível remover o evento.", NotificationVariant.ERROR);
                return false;
            }
        } catch (err) {
            onShowNotification("Não foi possível remover o evento.", NotificationVariant.ERROR);
            return false;
        } finally {
            onLoading(false);
        }
    }

    const handleDeleteEvent = async (deleteEvent) => {
        if (deleteEvent) {
            let newEventsSelected = eventsSelected.filter(item => item != deleteEvent);
            await handleChangeEvents(newEventsSelected);
        } 
    }

    const fetchEventsDynamics = async () => {
        onLoading(true);
        let result = [];

        try {
            const response = await LLMEventService.getAllEventDynamics();
            if (response?.success) {
                result = response?.data;
            } else {
                onShowNotification("Não foi possível recuperar os eventos dinâmicos.", NotificationVariant.ERROR);
            }
            return result;
        } catch (err) {
            onShowNotification("Não foi possível recuperar os eventos dinâmicos.", NotificationVariant.ERROR);
            return result;
        } finally {
            onLoading(false);
        }
    }

    const fetchEventsDynamicsByLLM = async () => {
        onLoading(true);
        let result = [];

        try {
            const response = await LLMService.getAllEventDynamicsByLLM(llm?.id);
            if (response?.success) {
                result = response?.data;
            } else {
                onShowNotification("Não foi possível recuperar os eventos.", NotificationVariant.ERROR);
            }
            return result;
        } catch (err) {
            onShowNotification("Não foi possível recuperar os eventos.", NotificationVariant.ERROR);
        } finally {
            onLoading(false);
        }
    }

    const loadInitialStateComponent = async () => {
        let eventsSelecteds = [];
        const eventsDynamic = await fetchEventsDynamics();
        const eventsDynamicByLlm = await fetchEventsDynamicsByLLM();

        if (eventsDynamicByLlm.length > 0) {
            const validIds = new Set(eventsDynamicByLlm.map(e => e.llmeventid));
            eventsSelecteds = eventsDynamic.filter(event => validIds.has(event.id));
        }

        setEventsDynamics(eventsDynamic);
        setEventsSelected(eventsSelecteds);  
    }

    useEffect(() => {
        if (llm) {
            loadInitialStateComponent();
        }  
    }, [llm]);

    return (
        <div style={{ paddingTop: '16px' }}>
          <Container component='main' maxWidth='lg'>
            <div className={classes.paper} style={{ marginTop: 0 }}>
                <Grid item xs={12} sm={6} md={4} >
                    <AutoCompleteMultipleSelectSimple 
                        label={intl.formatMessage({ id: "event" })} 
                        options={eventsDynamics} 
                        changeSelect={handleChangeEvents} 
                        selected={eventsSelected}
                        limitTags={9}
                    />
                </Grid>

                {
                    eventsSelected?.length > 0 && (
                        <div style={{marginTop: '2rem', width: '100%'}}>
                            <Typography variant="h6" style={{ textAlign: 'left' }}>
                                Eventos Selecionados:
                            </Typography>
                            <Grid container spacing={2} style={{marginTop: '8px'}}>
                                {eventsSelected?.map(item => (
                                    <Grid item xs={12} sm={12} key={item?.id}>
                                        <EventDynamicAccordion
                                            llm={llm}
                                            llmEvent={item}
                                            onHandleDeleteEvent={handleDeleteEvent}
                                            onShowNotification={onShowNotification} 
                                            onLoading={onLoading}
                                        />
                                    </Grid>
                                ))}
                            </Grid>
                        </div>
                    )
                }  
            </div>  
          </Container>
      </div>
    )
}

export default injectIntl(withStyles(Styles)(LLMEventsDynamics));